<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>

    <v-layout row mt-3>
      <v-flex xs12>
        <h4 mt-2>LISTE DES OUVRIERS (Chantier)</h4>
        <v-divider></v-divider>
        <v-layout row>
          <v-flex xs3>
            <v-card-text class="text-xs-center">
              <v-chip color="cyan" text-color="white">
                <v-avatar class="cyan darken-4">{{
                  nbContratOuvriers
                }}</v-avatar
                >Contrat(s) ouvrier
              </v-chip>
            </v-card-text>
          </v-flex>

          <v-flex class="mb-1" xs12 md3>
            <v-card-text class="text-xs-center">
              <v-chip
                label
                outline
                color="primary darken-1"
                class="elevation-4"
                style="width:100%"
              >
                <span class="subheading">Total : </span>
                <span class="title"
                  >&nbsp {{ new Intl.NumberFormat().format(mntTotalOuv) }}
                </span>
              </v-chip>
            </v-card-text>
          </v-flex>

          <v-flex class="mb-1" xs12 md3>
            <v-card-text class="text-xs-center">
              <v-chip
                label
                outline
                color="green darken-1"
                class="elevation-4"
                style="width:100%"
              >
                <span class="subheading">Total payé: </span>
                <span class="title"
                  >&nbsp {{ new Intl.NumberFormat().format(mntTotalVerseOuv) }}
                </span>
              </v-chip>
            </v-card-text>
          </v-flex>

          <v-flex class="mb-1" xs10 md3>
            <v-card-text class="text-xs-center">
              <v-chip
                label
                outline
                color="orange darken-1"
                class="elevation-4"
                style="width:100%"
              >
                <span class="subheading">Total restant: </span>
                <span class="title"
                  >&nbsp
                  {{ new Intl.NumberFormat().format(mntTotalRestantOuv) }}
                </span>
              </v-chip>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex sm12 mt-2>
            <data-tables
              mt-3
              ml-1
              mr-1
              :data="listeOuvriers"
              style="width:99%;"
            >
              <el-table-column
                prop="nom"
                label="NOM"
                align="center"
                width="230"
                fixed
              ></el-table-column>
              <el-table-column
                prop="nbContrats"
                label="Nb CONTRAT(S)"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag type="info">
                    {{ scope.row.nbContrats }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="mntTotal"
                label="MONTANT TOTAL"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag>
                    {{ new Intl.NumberFormat().format(scope.row.mntTotal) }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column
                prop="mntTotalVerse"
                label="MONTANT PAYE"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag type="success">
                    {{
                      new Intl.NumberFormat().format(scope.row.mntTotalVerse)
                    }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="mntTotalRestant"
                label="MONTANT RESTANT"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag type="warning">
                    {{
                      new Intl.NumberFormat().format(scope.row.mntTotalRestant)
                    }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column label="Action" align="center" fixed="right">
                <template slot-scope="scope">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click="modalListeContrat(scope.row)"
                      fab
                      dark
                      small
                      color="blue"
                    >
                      <v-icon dark>list</v-icon>
                    </v-btn>
                    Détails...
                  </v-tooltip>
                </template>
              </el-table-column>
            </data-tables>
          </v-flex>
        </v-layout>
        <br />
        <h4 class="mt-2">LISTE DES PRESTATAIRES (Chantier)</h4>
        <v-divider></v-divider>
        <v-layout row>
          <v-flex xs3>
            <v-card-text class="text-xs-center">
              <v-chip color="cyan" text-color="white">
                <v-avatar class="cyan darken-4">{{ nbContratPrest }}</v-avatar
                >Contrat(s) prestataire
              </v-chip>
            </v-card-text>
          </v-flex>
          <v-flex class="mb-1" xs12 md3>
            <v-card-text class="text-xs-center">
              <v-chip
                label
                outline
                color="primary darken-1"
                class="elevation-4"
                style="width:100%"
              >
                <span class="subheading">Total : </span>
                <span class="title"
                  >&nbsp {{ new Intl.NumberFormat().format(mntTotalPrest) }}
                </span>
              </v-chip>
            </v-card-text>
          </v-flex>
          <v-flex class="mb-1" xs12 md3>
            <v-card-text class="text-xs-center">
              <v-chip
                label
                outline
                color="green darken-1"
                class="elevation-4"
                style="width:100%"
              >
                <span class="subheading">Total payé: </span>
                <span class="title"
                  >&nbsp
                  {{ new Intl.NumberFormat().format(mntTotalVersePrest) }}
                </span>
              </v-chip>
            </v-card-text>
          </v-flex>

          <v-flex class="mb-1" xs10 md3>
            <v-card-text class="text-xs-center">
              <v-chip
                label
                outline
                color="orange darken-1"
                class="elevation-4"
                style="width:100%"
              >
                <span class="subheading">Total restant: </span>
                <span class="title"
                  >&nbsp
                  {{ new Intl.NumberFormat().format(mntTotalRestantPrest) }}
                </span>
              </v-chip>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex sm12 mt-2>
            <data-tables
              mt-3
              ml-1
              mr-1
              :data="listePrestataires"
              style="width:99%;"
            >
              <el-table-column
                prop="nom"
                label="NOM"
                align="center"
                width="230"
                fixed
              ></el-table-column>
              <el-table-column
                prop="nbContrats"
                label="Nb CONTRAT(S)"
                align="center"
              ></el-table-column>

              <el-table-column
                prop="mntTotal"
                label="MONTANT TOTAL"
                align="center"
              >
                <template slot-scope="scope">
                  {{ new Intl.NumberFormat().format(scope.row.mntTotal) }}
                </template>
              </el-table-column>

              <el-table-column
                prop="mntTotalVerse"
                label="MONTANT PAYE"
                align="center"
              >
                <template slot-scope="scope">
                  {{ new Intl.NumberFormat().format(scope.row.mntTotalVerse) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="mntTotalRestant"
                label="MONTANT RESTANT"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    new Intl.NumberFormat().format(scope.row.mntTotalRestant)
                  }}
                </template>
              </el-table-column>

              <el-table-column label="Action" align="center" fixed="right">
                <template slot-scope="scope">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click="modalListeContrat(scope.row)"
                      fab
                      dark
                      small
                      color="blue"
                    >
                      <v-icon dark>list</v-icon>
                    </v-btn>
                    Détails...
                  </v-tooltip>
                </template>
              </el-table-column>
            </data-tables>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- CONTRAT OUVRIER-->
    <ContratOuvrier
      :idChant="idChantier"
      :show="showListeContrat"
      :type="typePrestataire"
      :idPrestataire="idPrest"
      @close="showListeContrat = false"
    >
    </ContratOuvrier>
    <!-- CONTRAT OUVRIER -->
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import ContratOuvrier from "@/components/boardChantier/Contrat_ouvrier";

export default {
  components: { Loading, ContratOuvrier },
  name: "ListePrestataire",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number, //0=>chef travaux 1=>chantier//2=>projet
      default: 0
    },
    listePrestataires: {
      type: Array
    },
    listeOuvriers: {
      type: Array
    },
    idChantier: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      //ONGLET OUVRIERS/PRESTATAIRES
      typePrestataire: 0,
      showListeContrat: false,
      idPrest: null,
      nbContratOuvriers: 0,
      mntTotalVerseOuv: 0,
      mntTotalRestantOuv: 0,
      mntTotalOuv: 0,

      nbContratPrest: 0,
      mntTotalVersePrest: 0,
      mntTotalRestantPrest: 0,
      mntTotalPrest: 0
    };
  },

  watch: {
    show: function(newValue, oldValue) {
      if (newValue == true) {
        this.nbContratPrest = 0;
        this.mntTotalVersePrest = 0;
        this.mntTotalRestantPrest = 0;
        this.mntTotalPrest = 0;

        this.nbContratOuvriers = 0;

        this.mntTotalVerseOuv = 0;
        this.mntTotalRestantOuv = 0;
        this.mntTotalOuv = 0;

        if(this.listeOuvriers.length != 0) {
          this.listeOuvriers.forEach(ouvrier => {
          let contrats = ouvrier.contrats;
          if (contrats != null) {
            this.nbContratOuvriers += ouvrier.nbContrats;

            this.mntTotalVerseOuv += ouvrier.mntTotalVerse;
            this.mntTotalRestantOuv += ouvrier.mntTotalRestant;
            this.mntTotalOuv += ouvrier.mntTotal;

            // contrats.forEach(cont=>{
            //     this.mntTotalVerseOuv +=  cont.mntVerserContrat
            //     this.mntTotalRestantOuv +=  cont.mntAverserContrat
            //     this.mntTotalOuv +=  cont.mntTotalContrat
            // })
          }
        });
        }
        
        if(this.listePrestataires.length != 0) { 
          this.listePrestataires.forEach(prestataire => {
          let contrats = prestataire.contrats;
          if (contrats != null) {
            this.nbContratPrest += prestataire.nbContrats;
            this.mntTotalVersePrest += prestataire.mntTotalVerse;
            this.mntTotalRestantPrest += prestataire.mntTotalRestant;
            this.mntTotalPrest += prestataire.mntTotal;

            // contrats.forEach(cont=>{
            //     this.mntTotalVersePrest +=  cont.mntVerserContrat
            //     this.mntTotalRestantPrest +=  cont.mntAverserContrat
            //     this.mntTotalPrest +=  cont.mntTotalContrat
            // })
          }
        });
        }
        
      }
    }
  },

  methods: {
    modalListeContrat(prestataire) {
      this.typePrestataire = prestataire.type;
      this.idPrest = prestataire.idPrest;
      this.showListeContrat = true;
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/boardTravaux/ListePrestataire.vue